import first from "../ProjectImages/husoy/20190423_145459.jpg";
import sec from "../ProjectImages/husoy/20190425_085348.jpg";
import third from "../ProjectImages/husoy/20190503_153318.jpg";
import fourth from "../ProjectImages/husoy/20190503_153330.jpg";
import fifth from "../ProjectImages/husoy/20190503_153343.jpg";
import sixth from "../ProjectImages/husoy/20190503_153412.jpg";
import nineth from "../ProjectImages/husoy/20190508_115402.jpg";
import tenth from "../ProjectImages/husoy/20190508_115410.jpg";
import elleventh from "../ProjectImages/husoy/20191122_175739.jpg";
import twelve from "../ProjectImages/husoy/20191122_221806.jpg";
import thirteen from "../ProjectImages/husoy/20210817_094224.jpg";
import fourteen from "../ProjectImages/husoy/20210817_094301.jpg";
import fifthteen from "../ProjectImages/husoy/20210817_094320.jpg";
import sixteen from "../ProjectImages/husoy/DSC_0150.jpg";
import seventeen from "../ProjectImages/husoy/innetak.jpg";

import eightteen from "../ProjectImages/husoy/20210817_094247.jpg";

export const husoyData = [
  {
    img: eightteen,
    title: "Image",
    cols: 2,
  },
  {
    img: fourteen,
    title: "Image",
    cols: 2,
  },
  {
    img: fifthteen,
    title: "Image",
    cols: 2,
  },
  {
    img: third,
    title: "Image",
    cols: 2,
  },
  {
    img: fourth,
    title: "Image",
    cols: 2,
  },
  {
    img: fifth,
    title: "Image",
    cols: 2,
  },
  {
    img: sixth,
    title: "Image",
    cols: 2,
  },

  {
    img: nineth,
    title: "Image",
    cols: 2,
  },
  {
    img: tenth,
    title: "Image",
    cols: 2,
  },
  {
    img: elleventh,
    title: "Image",
    cols: 2,
  },
  {
    img: twelve,
    title: "Image",
    cols: 2,
  },
  {
    img: thirteen,
    title: "Image",
    cols: 2,
  },

  {
    img: sixteen,
    title: "Image",
    cols: 2,
  },
  {
    img: seventeen,
    title: "Image",
    cols: 2,
  },
  {
    img: first,
    title: "Image",
    cols: 2,
  },
  {
    img: sec,
    title: "Image",
    cols: 2,
  },
];
